import { render } from "./CoinSkin.vue?vue&type=template&id=10e9a1d7&scoped=true&ts=true"
import script from "./CoinSkin.vue?vue&type=script&lang=ts"
export * from "./CoinSkin.vue?vue&type=script&lang=ts"

import "./CoinSkin.vue?vue&type=style&index=0&id=10e9a1d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e9a1d7"]])

export default __exports__